/* eslint-disable no-restricted-syntax */
/* eslint-disable no-alert */
/* eslint-disable no-restricted-globals */
// #region import
import React, { useEffect, useState } from 'react';
import GetMunicipality from '../../../api/MunicipalityAPI';
import { City, removeMunicipalityCodeZero } from '../../../models/municipality';
import { PostPushSend, target } from '../../../api/PushSendAPI';

import {
  CURRENT_LOCATION_TEXT,
  ERROR_MESSAGE_API,
  LOCATION_ALL_SELECTED_TEXT,
  MESSAGE_TEXT,
  NOTIFICATION_TYPE_TEXT,
  PUSH_INPUT_CONFIRM_TEXT,
  TITLE_TEXT,
  UPLOAD,
  URL_TEXT,
} from '../../../util/Const';
import { GetType } from '../GenericMethod';
// #endregion import

/**
 * 通知送信内容確認画面
 * @param history
 */
const NotificationSendingConfirm = (props: any) => {
  const { history, input, setInput, setIsInput } = props;

  // 市区町村リスト
  const [cityList, setCityList] = useState<City[]>([]);
  useEffect(() => {
    GetMunicipality()
      .then((response: any) => {
        const cityItems: City[] = [];
        for (const prefecture of response) {
          for (const city of prefecture.cities) {
            cityItems.push(city);
          }
        }
        setCityList(cityItems);
      })
      .catch(() => {
        alert(ERROR_MESSAGE_API);
      });
  }, []);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  if (!history) {
    return null;
  }

  const handleClickCloseBtn = () => {
    setInput(input);
    setIsInput(true);
  };

  const onClickSendBtn = async () => {
    try {
      const result = confirm('表示されている内容で通知を送信します。');
      if (result) {
        input.target = removeMunicipalityCodeZero(input.target);
        await PostPushSend(input);
        history.push('/PushLog');
      }
    } catch (error) {
      alert(ERROR_MESSAGE_API);
    }
  };

  let targetList: string = '';
  if (input.target.length > 0) {
    const list: string[] = [];
    input.target.forEach((item: target) => {
      const city = cityList.find((v) => v.city_code === item.city_code);
      let name = '';
      if (city) {
        name = city.city_name;
        if (item.village_code) {
          const village = city?.villages.find(
            (v) => v.village_code === item.village_code
          );
          if (village) {
            name += village.village_name;
          }
        }
      }
      list.push(name);
    });
    targetList = list.join('/');
  } else {
    targetList = LOCATION_ALL_SELECTED_TEXT;
  }

  // #region return
  return (
    <article id="sending_confirm" className="notification_sending">
      <h1>{PUSH_INPUT_CONFIRM_TEXT}</h1>
      <div>
        <dl>
          <dt>{TITLE_TEXT}</dt>
          <dd>
            <input disabled type="text" value={input.title} className="" />
          </dd>
          <dt>{MESSAGE_TEXT}</dt>
          <dd>
            <textarea disabled value={input.message} className="" />
          </dd>
          {input.target != null ? (
            <>
              <dt>{CURRENT_LOCATION_TEXT}</dt>
              <dd>{targetList}</dd>
            </>
          ) : null}
          {input.url != null ? (
            <>
              <dt>{URL_TEXT}</dt>
              <dd>{input.url}</dd>
            </>
          ) : null}
          {input.is_debug === 1 ? (
            <>
              <dt>テスト通知</dt>
              <dd>ON</dd>
            </>
          ) : null}
          <dt>{NOTIFICATION_TYPE_TEXT}</dt>
          <dd>{GetType(input.type)}</dd>
          <button type="button" className="btn" onClick={onClickSendBtn}>
            {UPLOAD}
          </button>
          <button type="button" className="btn" onClick={handleClickCloseBtn}>
            修正
          </button>
        </dl>
      </div>
    </article>
  );
  // #endregion return
};
export default NotificationSendingConfirm;
